import { gql } from '@apollo/client';

export const GET_SALESPERSON_EMAILS = gql`
  query GET_SALESPERSON_EMAILS {
    getSalespersonEmails
  }
`;
